
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16.5","height":"15"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-2631.977 -1320.277)","fill":"none","stroke":"#2e323f","stroke-linecap":"round"}},[_c('line',{attrs:{"x2":"15.5","transform":"translate(2632.477 1320.777)"}}),_c('line',{attrs:{"x2":"15.5","transform":"translate(2632.477 1324.277)"}}),_c('line',{attrs:{"x2":"15.5","transform":"translate(2632.477 1327.777)"}}),_c('line',{attrs:{"x2":"15.5","transform":"translate(2632.477 1331.277)"}}),_c('line',{attrs:{"x2":"15.5","transform":"translate(2632.477 1334.777)"}})])])
          )
        }
      }
    